import request from '../../request';

// const moment = window.moment;
let lastVisitedActivityUrl;

if (localStorage.getItem('lastVisitedActivityUrl') !== null) {
  lastVisitedActivityUrl = localStorage.getItem('lastVisitedActivityUrl');
}

export default {
  state: {
    loading: false,
    statusCode: undefined,
    activity: {},
    lastVisitedActivityUrl,
  },
  mutations: {
    setStatus(state, payload) {
      Object.assign(state, { statusCode: payload });
    },
    setActivity(state, payload) {
      Object.assign(state, { activity: payload });
    },
    setLastActivityUrl(state, url) {
      Object.assign(state, { lastVisitedActivityUrl: url });
    },
    setLoading(state, loading) {
      Object.assign(state, { loading });
    },
  },
  actions: {
    getActivityPublic(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('setStatus', undefined);
        context.commit('setLoading', true);
        context.dispatch('showWaiting');
        request.make({
          type: 'GET',
          url: `${process.env.API_URL}activity/${payload.slug}`,
        }, (err, res) => {
          context.dispatch('hideWaiting');
          context.commit('setStatus', res.status);
          context.commit('setLoading', false);
          if (res.status === 200) {
            context.commit('setActivity', res.body.data);
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    setLastActivityUrl(context, url) {
      localStorage.setItem('lastVisitedActivityUrl', url);
      context.commit('setLastActivityUrl', url);
    },
  },
  getters: {
    activityRegion(state) {
      let region;
      if (typeof state.activity.locations !== 'undefined') {
        if (typeof state.activity.locations.data !== 'undefined') {
          state.activity.locations.data.forEach((location) => {
            if (location.location_type_id === 3) {
              region = location.name;
            }
          });
        }
      }
      return region;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/activity.js